"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsMixinDeviceBase = void 0;
const _1 = __importStar(require("."));
const { deviceManager } = _1.default;
class SettingsMixinDeviceBase extends _1.MixinDeviceBase {
    constructor(options) {
        super(options);
        this.settingsGroup = options.group;
        this.settingsGroupKey = options.groupKey;
        process.nextTick(() => deviceManager.onMixinEvent(this.id, this, _1.ScryptedInterface.Settings, null));
    }
    async getSettings() {
        const settingsPromise = this.mixinDeviceInterfaces.includes(_1.ScryptedInterface.Settings) ? this.mixinDevice.getSettings() : undefined;
        const mixinSettingsPromise = this.getMixinSettings();
        const allSettings = [];
        try {
            const settings = (await settingsPromise) || [];
            allSettings.push(...settings);
        }
        catch (e) {
            const name = this.name;
            const description = `${name} Extension settings failed to load.`;
            this.console.error(description, e);
            allSettings.push({
                key: Math.random().toString(),
                title: name,
                value: 'Settings Error',
                group: 'Errors',
                description,
                readonly: true,
            });
        }
        try {
            const mixinSettings = (await mixinSettingsPromise) || [];
            for (const setting of mixinSettings) {
                setting.group = setting.group || this.settingsGroup;
                setting.key = this.settingsGroupKey + ':' + setting.key;
            }
            allSettings.push(...mixinSettings);
        }
        catch (e) {
            const name = deviceManager.getDeviceState(this.mixinProviderNativeId).name;
            const description = `${name} Extension settings failed to load.`;
            this.console.error(description, e);
            allSettings.push({
                key: Math.random().toString(),
                title: name,
                value: 'Settings Error',
                group: 'Errors',
                description,
                readonly: true,
            });
        }
        return allSettings;
    }
    async putSetting(key, value) {
        const prefix = this.settingsGroupKey + ':';
        if (!key?.startsWith(prefix)) {
            return this.mixinDevice.putSetting(key, value);
        }
        if (!await this.putMixinSetting(key.substring(prefix.length), value))
            deviceManager.onMixinEvent(this.id, this, _1.ScryptedInterface.Settings, null);
    }
    async release() {
        await deviceManager.onMixinEvent(this.id, this, _1.ScryptedInterface.Settings, null);
    }
}
exports.SettingsMixinDeviceBase = SettingsMixinDeviceBase;
//# sourceMappingURL=settings-mixin.js.map